
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import * as cdn from "@coredination/components"
import MapLocations from "@/graphql/map/maplocations.graphql"
import { CircularLoader } from "@coredination/components"
import MapContainer from "@/components/misc/MapContainer.vue"

@Component({
    components: {
        MapContainer: () => import("@/components/misc/MapContainer.vue"),
        CircularLoader,
    },
    apollo: {
        // if pos I want to fetch this from a cache entity
        me: cdn.graphql.me,
        jobLocations: {
            query: MapLocations,
            variables() {
                return {
                    layers: {
                        jobs: true
                    },
                    filter: {
                        from: new Date().setHours(0,0,0,0),
                        to: new Date(new Date().setDate(new Date().getDate() + 7)).setHours(0,0,0,0),
                        allStates: true,
                        unassigned: true,
                        which: "mine"
                    }
                }
            },
            update(response: any){
                return response.mapLocations
            },
            result(result:any){
                this.centerWhenReady()
            },
            pollInterval: 300000, // pollInterval seems broken in general, it doesn't refetch
            error(error) {
                console.error('could not fetch map locations', error)
                //this.mapLocations = null
            }
        },
        unassignedJobLocations: {
            query: MapLocations,
            variables() {
                return {
                    layers: {
                        jobs: true
                    },
                    filter: {
                        from: new Date().setHours(0,0,0,0),
                        to: new Date(new Date().setDate(new Date().getDate() + 7)).setHours(0,0,0,0),
                        allStates: true,
                        unassigned: true,
                        untimed: true,
                        which: "unassigned"
                    }
                }
            },
            update(response: any){
                return response.mapLocations
            },
            result(result:any){
                this.centerWhenReady()
            },
            pollInterval: 300000,
        },
    },
})
export default class MapView extends Vue {
    me: any = {}
    loading: boolean = false

    currentLocation: any = null

    geolocationTimeout: boolean = false

    @Prop()
    locations?: any[]
    jobLocations?: any[]
    unassignedJobLocations?: any[]

    @Prop({ default: null })
    centerLocation?: any

    hasCentered = false

    containerHeight = window.innerHeight ? (window.innerHeight - 112) + "px" : "80vh"

    mounted(){
        this.refresh()
    }

    refresh(toast?: boolean){
        console.log('refreshing locations')
        this.$apollo.queries.jobLocations.refetch()
        .then(response => {
            var msg: string = this.$t("map_updated_locations") as string
            if (toast) this.$toast.success(msg, { timeout: 1200 })
        })
        .catch(error => {
            var msg: string = this.$t("map_failed_update_locations") as string
            if (toast) this.$toast.error(msg, { timeout: 1200 })
        })
        this.$apollo.queries.unassignedJobLocations.refetch()
    }

    centerWhenReady(){
        if (!this.hasCentered && !(sessionStorage.map_center && sessionStorage.map_zoom) && this.$refs.map && this.jobLocations && this.unassignedJobLocations){
            //(this.$refs.map as MapContainer).centerAndFit()
            this.hasCentered = true
        }
    }
    resize(){
        this.containerHeight = (window.innerHeight - 112) + "px"
    }

    get computedLocations() {
        let locations: any[] = []
        if (this.locations && this.locations.length > 0) locations = locations.concat(this.locations)
        if (this.jobLocations && this.jobLocations.length > 0) locations = locations.concat(this.jobLocations)
        if (this.unassignedJobLocations && this.unassignedJobLocations.length > 0) locations = locations.concat(this.unassignedJobLocations) // temporary solution, see above
        return locations.filter(loc => loc.coordinates && loc.coordinates.longitude && loc.coordinates.latitude)
    }
}
